/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const WORKER_DATA_FRAGMENT = gql`
  fragment workerData on Worker {
    id
    owner
    name
    version
    departmentVersion
    knowledgeId
    departmentId
    procedureId
    originalWorkerId
    createdAt
    state
    isArchived
    features
    stage
    replayWorkerId
  }
`;

export const WORKER_FORK_EXECUTION_FRAGMENT = gql`
  fragment WorkerForkExecutionInfo on Worker {
    forkExecutionInfo {
      items {
        answer
        createdBy
        documentToken
        internalState
        internalStateLastUpdatedAt
        internalStateMessage
        lineId
        lineToken
        metadata {
          learningId
          questionId
          requestId
        }
        version
        workItemId
        workerId
      }
    }
  }
`;
